import axiosInstance from "../../axiosInstance";

/**
 * Get Editor list
 * @param {*} journal
 * @param {*} designation
 * @returns
 */
const getEditorList = async ({ journal, designation = "" }) => {
  try {
    const res = await axiosInstance.get(
      `/api/editor/websiteEditorList?journal=${journal}&designation=${designation}`
    );

    if (res.status === 200) {
      return res.data;
    } else {
    }
  } catch (error) {}
};

export default getEditorList;
